import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import Logo from "@/components/Logo";

export default function Navigation() {
  const { pathname } = useLocation();
  const { scrollY } = useScroll();
  const bg = useTransform(
    scrollY,
    [0, 120],
    ["rgba(11,11,11,0.45)", "rgba(11,11,11,0.78)"]
  );
  const blur = useTransform(scrollY, [0, 120], ["blur(14px)", "blur(24px)"]);

  return (
    <motion.nav
      style={{
        backgroundColor: bg,
        backdropFilter: blur,
        WebkitBackdropFilter: blur,
      }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.06] transition-colors"
      data-testid="main-navigation"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5 group"
          data-testid="nav-logo-link"
        >
          <Logo size={28} />
          <span
            className="font-sans font-semibold text-foreground tracking-[-0.025em] text-[15px] sm:text-base"
          >
            Nisky Auto
          </span>
        </Link>
        <div className="flex items-center gap-2 sm:gap-3">
          {pathname !== "/" && (
            <Link
              to="/"
              className="text-sm text-foreground/80 hover:text-foreground transition-colors hidden sm:inline"
              data-testid="nav-home-link"
            >
              Home
            </Link>
          )}
          <Link
            to="/status"
            className="text-sm text-foreground/80 hover:text-foreground transition-colors"
            data-testid="nav-status-link"
          >
            Status
          </Link>
          <motion.div
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
          >
            <Link
              to="/book"
              className="inline-flex items-center px-5 py-2.5 rounded-full font-medium text-[13px]"
              style={{
                background: "var(--gold)",
                color: "#0b0b0b",
                letterSpacing: "-0.01em",
                textDecoration: "none",
                transition: "all 0.3s cubic-bezier(0.25,0.46,0.45,0.94)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--gold-light)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(138,138,138,0.30)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "var(--gold)";
                e.currentTarget.style.boxShadow = "none";
              }}
              data-testid="nav-book-button"
            >
              Book
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.nav>
  );
}
